const ID_PAGE = 'p'
const ID_ROW = 'r'
const ID_COLUMN = 'c'
const ID_TEXT = 't'
const ID_IMAGE = 'i'
const ID_VIDEO = 'v'

const IDENTIFICATIONS = {
	ID_PAGE,
	ID_ROW,
	ID_COLUMN,
	ID_TEXT,
	ID_IMAGE,
	ID_VIDEO
}

const settings = {
	IDENTIFICATIONS
}

export default settings